import getCloudinaryThumbnailUrl from "./getCloudinaryThumbnailUrl"

function preCacheCloudinaryImages(thumbnail) {
  const sizes = [280, 500]
  try {
    sizes.forEach((size) => {
      const cloudinaryUrl = getCloudinaryThumbnailUrl(thumbnail, size)
      const img = new Image()
      img.src = cloudinaryUrl
    })
  } catch (e) {
    console.error(e)
  }
}

export default preCacheCloudinaryImages
